import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-prefooter-loader',
  standalone: true,
  templateUrl: './prefooter-loader.component.html',
  styleUrls: ['../prefooter.component.scss'],
  imports: [CommonModule, NgxSkeletonLoaderModule],
})
export class PrefooterLoaderComponent {}
